import Axios from '~/utils/axios';
import { sentryCaptureException } from '~/errors/sentry';
import { useQuery } from 'react-query';
type ReviewsListProps = {
   productId?: string;
   sortBy?: string | null;
   pageNumber?: number | null;
   perPage?: number | null;
   searchValue?: string[] | null;
   venue_visibility?: string;
};
const useReviewsList = ({
   productId,
   sortBy,
   pageNumber,
   perPage,
   searchValue,
   venue_visibility,
}: ReviewsListProps) => {
   const getReviewsList = async ({ queryKey }: any) => {
      const { sortBy, perPage } = queryKey[1];
      const endpoint = productId ? `/venues/${productId}/reviews` : 'hy-providers/v1/reviews-list';
      const { data = {} } = await Axios.get(endpoint, {
         params: {
            sort: sortBy,
            page: pageNumber,
            per_page: perPage || 10,
            keyword: searchValue,
            venue_visibility: venue_visibility,
         },
      });
      return data.data ? data.data : data;
   };

   return useQuery(
      ['reviews-list', { productId, sortBy, pageNumber, perPage, searchValue, venue_visibility }],
      getReviewsList,
      {
         refetchOnWindowFocus: false,
         onError: (error: Error) => {
            sentryCaptureException(error, { tags: { journey: 'business' } });
         },
      }
   );
};
export default useReviewsList;
